import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "config/api";

export default function ProfileInfo() {
  const [user, setUser] = useState(null);
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    detailed_address: "",
    seller_type: "online",
  });

  // ✅ Fetch user profile
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) return;

        const res = await axios.get(`${API_BASE_URL}/api/users/me/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(res.data);
        setFormData({
          first_name: res.data.first_name || "",
          last_name: res.data.last_name || "",
          city: res.data.city || "",
          neighborhood: res.data.neighborhood || "",
          detailed_address: res.data.detailed_address || "",
          seller_type: res.data.seller_type || "online",
        });
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      }
    };
    fetchUser();
  }, []);

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Handle save (PUT request)
  const handleSave = async () => {
    try {
      const token = localStorage.getItem("access_token");
      await axios.put(`${API_BASE_URL}/api/users/update-profile/`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser((prev) => ({ ...prev, ...formData }));
      setEditing(false);
      alert("✅ Profile updated successfully!");
    } catch (error) {
      console.error("Profile update failed:", error);
      alert("❌ Failed to update profile.");
    }
  };

  if (!user) return <p>Loading profile...</p>;

  return (
    <div className="bg-neutral-900 rounded-2xl border border-neutral-800 p-6 shadow-lg flex flex-col md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-2xl font-semibold mb-2">Your Profile</h1>
        <p className="text-gray-400 text-sm mb-4">
          Manage your connected accounts and business information.
        </p>
        {!editing ? (
          <div className="space-y-1 text-gray-300">
            <p><span className="text-gray-500 mr-2">Name:</span>{user.first_name} {user.last_name}</p>
            <p><span className="text-gray-500 mr-2">Email:</span>{user.email}</p>
            <p><span className="text-gray-500 mr-2">City:</span>{user.city || "Not set"}</p>
            <p><span className="text-gray-500 mr-2">Neighborhood:</span>{user.neighborhood || "Not set"}</p>
            <p><span className="text-gray-500 mr-2">Address:</span>{user.detailed_address || "Not provided"}</p>
            <p><span className="text-gray-500 mr-2">Seller Type:</span>{user.seller_type}</p>
            <p><span className="text-gray-500 mr-2">Membership Tier:</span>{user.membership_tier}</p>
          </div>
        ) : (
          <div className="space-y-3 text-gray-300">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm text-gray-500 mb-1">First Name</label>
                <input type="text" name="first_name" value={formData.first_name}
                  onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white" />
              </div>
              <div>
                <label className="block text-sm text-gray-500 mb-1">Last Name</label>
                <input type="text" name="last_name" value={formData.last_name}
                  onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white" />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm text-gray-500 mb-1">City</label>
                <input type="text" name="city" value={formData.city}
                  onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white" />
              </div>
              <div>
                <label className="block text-sm text-gray-500 mb-1">Neighborhood</label>
                <input type="text" name="neighborhood" value={formData.neighborhood}
                  onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white" />
              </div>
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Detailed Address</label>
              <input type="text" name="detailed_address" value={formData.detailed_address}
                onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white" />
            </div>
            <div>
              <label className="block text-sm text-gray-500 mb-1">Seller Type</label>
              <select name="seller_type" value={formData.seller_type}
                onChange={handleChange} className="w-full px-3 py-2 bg-neutral-800 border border-neutral-700 rounded-md text-white">
                <option value="online">Online Seller</option>
                <option value="local">Local Shop Owner</option>
                <option value="both">Both</option>
              </select>
            </div>
          </div>
        )}
      </div>

      <div className="mt-6 md:mt-0 flex gap-2">
        {!editing ? (
          <button
            onClick={() => setEditing(true)}
            className="bg-yellow-400 hover:bg-yellow-300 text-black px-4 py-2 rounded-md font-medium"
          >
            Edit Profile
          </button>
        ) : (
          <>
            <button
              onClick={handleSave}
              className="bg-green-500 hover:bg-green-400 text-black px-4 py-2 rounded-md font-medium"
            >
              Save
            </button>
            <button
              onClick={() => setEditing(false)}
              className="bg-neutral-700 hover:bg-neutral-600 text-white px-4 py-2 rounded-md font-medium"
            >
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
}